export enum SweepEventsType {
  Subscribe = 'subscribe',
  MoveTo = 'move_to',
  CancelTourObjectChanges = 'calcel_tour_object_changes',
  SetActiveNodeEditView = 'set_active_node_edit_view'
}
